import { render, staticRenderFns } from "./Topic2Wrapper.vue?vue&type=template&id=ca4a259a&scoped=true"
import script from "./Topic2Wrapper.vue?vue&type=script&lang=js"
export * from "./Topic2Wrapper.vue?vue&type=script&lang=js"
import style0 from "./Topic2Wrapper.vue?vue&type=style&index=0&id=ca4a259a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4a259a",
  null
  
)

export default component.exports